import { TableColumProps } from "@/components/molecules/Table";
import { fakeI18n } from "@/i18n";
import { Contract, ContractSortProperty } from "@/shared/domain";

export const contractTableColumns: TableColumProps<Contract, ContractSortProperty>[] = [
    {
        unsortableKey: "title",
        label: fakeI18n.t("Common.Description"),
        notSortable: true,
        width: 22,
    },
    {
        unsortableKey: "risks.name",
        label: fakeI18n.t("Common.Concerns"),
        notSortable: true,
        width: 15,
    },
    {
        sortableKey: "amount",
        label: fakeI18n.t("Common.Amount"),
        width: 11,
    },
    {
        sortableKey: "periodicity.name",
        label: fakeI18n.t("Common.Periodicity"),
        width: 11,
    },
    {
        sortableKey: "effectiveDate",
        label: fakeI18n.t("Common.EffectiveDate"),
        width: 11,
    },

    {
        sortableKey: "dueDate",
        label: fakeI18n.t("Common.DueDateShort"),
        width: 11,
    },
    {
        sortableKey: "state.id",
        label: fakeI18n.t("Common.Status"),
        width: 19,
    },
    // {
    //     labelKey: "categories.id",
    //     label: "",
    //     notSortable: true,
    //     width: 1,
    // },
];
